import AssignSmartTipModal from './AssignSmartTipModal';

export default AssignSmartTipModal;
